import { render, staticRenderFns } from "./RegisterModuleQuizQuestion.vue?vue&type=template&id=0c133696&scoped=true&"
import script from "./RegisterModuleQuizQuestion.vue?vue&type=script&lang=js&"
export * from "./RegisterModuleQuizQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModuleQuizQuestion.vue?vue&type=style&index=0&id=0c133696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c133696",
  null
  
)

export default component.exports